/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignableAssetResponseDto } from './AssignableAssetResponseDto';
import {
    AssignableAssetResponseDtoFromJSON,
    AssignableAssetResponseDtoFromJSONTyped,
    AssignableAssetResponseDtoToJSON,
    AssignableAssetResponseDtoToJSONTyped,
} from './AssignableAssetResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListAssignableAssetsResponseDto
 */
export interface ListAssignableAssetsResponseDto {
    /**
     * 
     * @type {Array<AssignableAssetResponseDto>}
     * @memberof ListAssignableAssetsResponseDto
     */
    data: Array<AssignableAssetResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListAssignableAssetsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListAssignableAssetsResponseDto interface.
 */
export function instanceOfListAssignableAssetsResponseDto(value: object): value is ListAssignableAssetsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssignableAssetsResponseDtoFromJSON(json: any): ListAssignableAssetsResponseDto {
    return ListAssignableAssetsResponseDtoFromJSONTyped(json, false);
}

export function ListAssignableAssetsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssignableAssetsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssignableAssetResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssignableAssetsResponseDtoToJSON(json: any): ListAssignableAssetsResponseDto {
    return ListAssignableAssetsResponseDtoToJSONTyped(json, false);
}

export function ListAssignableAssetsResponseDtoToJSONTyped(value?: ListAssignableAssetsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssignableAssetResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

